import { PORTAL_UI_V2 } from "../config/uiTheme";
import CreateMachineLegacy from "./forms/CreateMachineLegacy";
import CreateMachineV2 from "./forms/CreateMachineV2";

const CreateMachine = () => (PORTAL_UI_V2 ? <CreateMachineV2 /> : <CreateMachineLegacy />);

export default CreateMachine;
